requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    themeBase.onFirstScroll(!themeBase.isDesktop || !window.themeSettings.animatedLogoEnabled ? true : false, () => {
      class StickyHeader extends HTMLElement {
        constructor() {
          super();
          this.init();
        }

        init() {
          this.stickyClass = 'sticky-header__content--sticky';
          this.stickyBodyClass = 'sticky-header-fixed';
          this.fixedMenuBodyClass = 'sticky-header-fixed--fixed-mega-menu';
          this.params = {
            bp: 1024
          };
          this.currentScroll = 0;
          this.fixedScrollOffset = 100;

          this.hideWhenScrollDown = this.dataset.hideWhenScrollDown === 'true' ? true : false;
          this.enableDesktop = this.dataset.enableDesktop === 'true';
          this.enableMobile = this.dataset.enableMobile === 'true';
          this.fixedMenu = this.dataset.fixedMenu === 'true';

          if (this.enableDesktop) {
            this.params.desktop = {
              contentSelector: '.sticky-header__content-desktop',
              limitSide: 'top',
              fade: true,
              duration: 300
            };
          }

          if (this.enableMobile) {
            this.params.mobile = {
              contentSelector: '.sticky-header__content-mobile',
              limitSide: 'top',
              limitOffset: 0, // PMC: float the mobile header from the first pixel of scroll (was 300)
              fade: false
            };
          }
          if (this.params.mobile) {
            this.stickyMobile = this.querySelector(this.params.mobile.contentSelector);

            if (this.stickyMobile) {
              this.spacerMobile = document.createElement('div');
              this.spacerMobile.classList.add('sticky-header__spacer');
              this.spacerMobile.classList.add('sticky-header__spacer--m');
              this.stickyMobile.parentNode.insertBefore(this.spacerMobile, this.stickyMobile);
            } else {
              this.params.mobile = false;
            }
          }
          if (this.params.desktop) {
            this.stickyDesktop = this.querySelector(this.params.desktop.contentSelector);
            this.fixedFooter = document.querySelector('fixed-footer');

            if (this.stickyDesktop) {
              this.spacerDesktop = document.createElement('div');
              this.spacerDesktop.classList.add('sticky-header__spacer');
              this.spacerDesktop.classList.add('sticky-header__spacer--d');
              this.stickyDesktop.parentNode.insertBefore(this.spacerDesktop, this.stickyDesktop);
            } else {
              this.params.desktop = false;
            }
          }
          if (this.fixedMenu) document.body.classList.add(this.fixedMenuBodyClass);

          const onResize = () => {
            if (themeBase.isFreezeScrollEnable) return;

            this.bp = themeBase.isDesktop ? 'desktop' : 'mobile';
            this.currentSticky = themeBase.isDesktop ? this.stickyDesktop : this.stickyMobile;
            this.currentSpacer = themeBase.isDesktop ? this.spacerDesktop : this.spacerMobile;

            if (themeBase.isTablet) {
              if (this.currentSticky) {
                this.unfix(this.stickyMobile, this.spacerMobile);
                this.unfix(this.stickyDesktop, this.spacerDesktop);
                this.spacerMobile.classList.remove('sticky-header__spacer--visible');
                this.spacerDesktop.classList.remove('sticky-header__spacer--visible');
              }
              this.currentSticky = null;
            }

            if (!this.currentSticky) return;
            if (themeBase.isDesktop) {
              if (this.spacerDesktop) this.spacerDesktop.classList.add('sticky-header__spacer--visible');
              if (this.spacerMobile) {
                this.spacerMobile.classList.remove('sticky-header__spacer--visible');
                if (this.stickyMobile.classList.contains(this.stickyClass)) {
                  this.unfix(this.stickyMobile, this.spacerMobile);
                }
              }
            } else {
              if (this.spacerMobile) this.spacerMobile.classList.add('sticky-header__spacer--visible');
              if (this.spacerDesktop) {
                this.spacerDesktop.classList.remove('sticky-header__spacer--visible');

                if (this.stickyDesktop.classList.contains(this.stickyClass)) {
                  this.unfix(this.stickyDesktop, this.spacerDesktop);
                }
              }
            }

            document.documentElement.style.setProperty('--sticky-header-spacing', `${themeBounds.get(this.currentSticky).height / 10}rem`);
          };

          const onScroll = () => {
            if (!this.currentSticky || themeBase.isFreezeScrollEnable) return;

            const spacerParams = themeBounds.get(this.currentSpacer);
            const limitSide = this.params[this.bp].limitSide;
            const limitOffset = this.params[this.bp].limitOffset;
            let limit = 0;
            let animatedLogoVisible = false;
            let alwaysFixSticky = false;
            let isFixedFooter = false;

            if (this.fixedFooter && this.fixedFooter.isVisible) {
              isFixedFooter = true;
            }

            if (limitSide === 'top') {
              limit = 0;
            } else if (limitSide === 'bottom') {
              limit = this.currentSticky.classList.contains(this.stickyClass) ? spacerParams.height : themeBounds.get(this.currentSticky).height;
            }

            if (limitOffset) {
              limit = limit + limitOffset;
            }

            limit *= -1;

            if (
              spacerParams.top < 0 &&
              this.animatedLogo &&
              window.getComputedStyle(this.animatedLogo).getPropertyValue('display') !== 'none' &&
              themeBounds.get(this.animatedLogo).bottom + 200 > 0
            ) {
              animatedLogoVisible = true;
            }
            if (
              animatedLogoVisible ||
              (spacerParams.top < limit && !this.hideWhenScrollDown)
            ) {
              alwaysFixSticky = true;
            }

            if (
              alwaysFixSticky ||
              (
                spacerParams.top < limit &&
                window.pageYOffset < this.currentScroll &&
                !this.querySelectorAll('.menu .visible').length &&
                !isFixedFooter &&
                (themeSettings.disableStickyHeader === undefined || !themeSettings.disableStickyHeader())
              )
            ) {
              if (
                !this.currentSticky.classList.contains(this.stickyClass) &&
                (alwaysFixSticky || (!this.unfixedScroll || window.pageYOffset < this.unfixedScroll)) &&
                !themeSettings.manuallyIgnoreStickyHeader
              ) {
                this.fix(this.currentSticky, this.currentSpacer);
              }
              this.checkHeight(this.currentSticky, this.params[this.bp]);
              if (!themeBase.isFreezeScrollEnable) {
                this.fixedScroll = window.pageYOffset + this.fixedScrollOffset;
              }
            } else {
              if (
                (this.querySelectorAll('.menu .visible').length && spacerParams.top >= limit) ||
                (spacerParams.top >= limit && this.currentSticky.classList.contains(this.stickyClass)) ||
                (this.currentSticky.classList.contains(this.stickyClass) && (!this.fixedScroll || window.pageYOffset > this.fixedScroll) && !this.querySelectorAll('.menu .visible').length)
              ) {
                this.unfix(this.currentSticky, this.currentSpacer);
              }

              this.unfixedScroll = window.pageYOffset - this.fixedScrollOffset;
            }

            if (!this.currentSticky.classList.contains(this.stickyClass)) this.currentSpacer.removeAttribute('style');

            this.currentScroll = window.pageYOffset;
          };

          onResize();
          onScroll();

          window.addEventListener('throttle30fpsResize', () => {
            onResize();
            onScroll();
          });
          window.addEventListener('throttle30fpsScroll', () => {
            onScroll();
          });
        }

        fix(sticky, spacer) {
          sticky.classList.add(this.stickyClass);
          document.body.classList.add(this.stickyBodyClass);
          setTimeout(() => window.dispatchEvent(new CustomEvent('updateStickySidebar')), 0);
        }

        unfix(sticky, spacer) {
          sticky.removeAttribute('style');
          sticky.classList.remove(this.stickyClass);
          document.body.classList.remove(this.stickyBodyClass);
          setTimeout(() => window.dispatchEvent(new CustomEvent('updateStickySidebar')), 0);
        }

        checkHeight(sticky, obj) {
          if (!obj.height) return;

          const spacerParams = themeBounds.get(this.currentSpacer);
          const height = spacerParams.bottom <= obj.height ? obj.height : spacerParams.bottom;

          sticky.style.minHeight = `${height}px`;
        }

        getStickyHeight() {
          if (this.currentSticky && this.params[this.bp] && this.currentSticky.classList.contains(this.stickyClass)) {
            if (this.params[this.bp].height) {
              return this.params[this.bp].height;
            } else {
              return themeBounds.get(this.currentSticky).height;
            }
          } else {
            return 0;
          }
        }
      }

      customElements.define('sticky-header', StickyHeader);
    });
  });
});